import { Carousel } from "antd";
import React from "react";
import "./DynamicCarousel.css";

const DynamicCarousel = ({ content }) => {
  return (
    <div className="carousel-container">
      <Carousel
        autoplay
        className="custom-carousel"
        dotPosition="bottom"
        dots={{ className: "custom-dots" }}
      >
        {content.map((item, index) => (
          <div key={index} className="carousel-slide">
            <div className="carousel-content">
              {item.imageSrc && (
                <img
                  alt={item.title}
                  src={item.imageSrc}
                  className="carousel-image"
                />
              )}
              <div className="carousel-text">
                <h3 className="carousel-title">{item.title}</h3>
                <p className="carousel-description">{item.textToDisplay}</p>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default DynamicCarousel;
